import { AsyncPipe, NgIf, NgTemplateOutlet } from "@angular/common";
import { Component, ContentChild, OnInit, TemplateRef } from "@angular/core";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateHelper } from "../../helpers/translate.helper";
import { TranslateDto } from "src/app/core/models/translate/translate.dto";
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { LoadingService } from "src/app/core/services/loading/loading.service";
import { Observable } from "rxjs";

@Component({
    selector: "loading-button",
    templateUrl: "./loading-button.component.html",
    styleUrls: ["./loading-button.component.scss"],
    imports: [ MatButtonModule, MatIconModule, MatProgressSpinnerModule, TranslatePipe, AsyncPipe, NgIf, NgTemplateOutlet],
    standalone: true,
})
export class LoadingButtonComponent implements OnInit {
    
    loading$: Observable<boolean>;
    listTraduction: TranslateDto = {} as TranslateDto;

    @ContentChild("icon")
    iconNormal: TemplateRef<any> | null = null;
    
    constructor(private loadingService: LoadingService) {
        this.loading$ = this.loadingService.loading$;
    }

    ngOnInit() {
        this.listTraduction = TranslateHelper.getTranslation("loading");
    }
}